import { IPagedListAction } from "../../components/ui/Declarations";

export const getRowClassName = (item: any, defaultRowClassName: string, rowFormatter?: (item: any) => string | null): string => {
    if (rowFormatter) {
        const customClassName = rowFormatter(item);
        if (customClassName) {
            return customClassName;
        }
    }
    return defaultRowClassName;
};

export const separateActions = (itemActions: IPagedListAction[]) => {
    const primaryActions = itemActions.filter((action) => action.primary === true);
    const secondaryActions = itemActions.filter((action) => action.primary !== true);
    return { primaryActions, secondaryActions };
};

export const buildPagesArray = (offset: number, total: number, pageSize: number): number[] => {
    const pageCount = Math.ceil(total / pageSize);
    const currentPageNumber = Math.floor(offset / pageSize) + 1;
    const pages: number[] = [];

    if (pageCount <= 7) {
        for (let i = 1; i <= pageCount; i++) {
            pages.push(i);
        }
    } else {
        if (currentPageNumber <= 4) {
            for (let i = 1; i <= 5; i++) {
                pages.push(i);
            }
            pages.push(-1);
            pages.push(pageCount);
        } else if (currentPageNumber >= pageCount - 3) {
            pages.push(1);
            pages.push(-1);
            for (let i = pageCount - 4; i <= pageCount; i++) {
                pages.push(i);
            }
        } else {
            pages.push(1);
            pages.push(-1);
            for (let i = currentPageNumber - 1; i <= currentPageNumber + 1; i++) {
                pages.push(i);
            }
            pages.push(-1);
            pages.push(pageCount);
        }
    }

    return pages;
};
